import { render, staticRenderFns } from "./LlClassificationWrap.vue?vue&type=template&id=54d0cb3f"
import script from "./LlClassificationWrap.vue?vue&type=script&lang=js"
export * from "./LlClassificationWrap.vue?vue&type=script&lang=js"
import style0 from "./LlClassificationWrap.vue?vue&type=style&index=0&id=54d0cb3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports